import React from "react";

const ThemeContext = React.createContext();
const StockContext = React.createContext();
const FilterContext = React.createContext();


export {FilterContext, StockContext, ThemeContext};